<template>
  <div style="width: 100%; height: 100%;">
    <p class="no_content" v-if="list.length === 0">暂无内容</p>
    <ul class="common_list" v-if="list.length > 0">
      <li class="pointer" v-for="(item, index) in list" :key="item.id" @click="$emit('toDetail', item.id)" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = ''">
        <el-image class="image" lazy :src="item.logo" fit="cover">
          <div slot="error" class="image_error">暂无图片</div>
        </el-image>
        <div class="list_info">
          <h3>{{ item.title }}</h3>
          <p><img v-if="hoverIndex !== index" src="@/assets/clock-icon.png" /><img v-else src="@/assets/clock-h-icon.png" /><span>发布日期 {{ item.createdAt | dateFormat }}</span></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'commonList',
  components: {},
  props: ['list'],
  data () {
    return {
      hoverIndex: ''
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>

<style scoped>
  .common_list { height: 100%; overflow: auto; }
  .common_list li { height: 40px; margin-bottom: 15px; }
  .common_list li:last-child { margin-bottom: 0; }
  .common_list li .image { width: 40px; height: 40px; border-radius: 3px; float: left; }
  .common_list li .list_info { margin-left: 46px; padding: 5px 0; }
  .common_list li h3 { font-size: 14px; font-weight: 600; color: #333333; line-height: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 3px; }
  .common_list li p img { width: 12px; height: 12px; margin-right: 5px; }
  .common_list li p span { font-size: 12px; font-weight: 400; color: #999999; line-height: 12px; }
  .common_list li:hover h3 { color: #77B950; }
  .common_list li:hover p span { color: #77B950; }
</style>



// WEBPACK FOOTER //
// src/components/list/list.vue